
import { NavigateFunction } from "react-router-dom";

let navigate: NavigateFunction | null = null;

export const initializeNavigation = (navigationFunction: NavigateFunction) => {
  navigate = navigationFunction;
};

export const navigationService = {
  // Home
  goToHome: () => {
    if (!navigate) throw new Error('Navigation not initialized');
    navigate("/home");
  },

  // Events
  goToEventDetails: (eventId: string, source: string) => {
    if (!navigate) throw new Error('Navigation not initialized');
    navigate(`/events/${eventId}?source=${source}`);
  },
  // RSVP flows
  goToRSVPNew: (eventId: string) => {
    if (!navigate) throw new Error('Navigation not initialized');
    navigate(`/events/${eventId}/rsvp`);
  },
  goToUpdateRSVP: (eventId: string) => {
    if (!navigate) throw new Error('Navigation not initialized');
    navigate(`/events/${eventId}/update-rsvp`);
  },
  goToCreateEvent: () => {
    if (!navigate) throw new Error('Navigation not initialized');
    navigate("/create-event");
  },
  goToReviewEvent: () => {
    if (!navigate) throw new Error('Navigation not initialized');
    navigate("/review-event");
  },

  // Profile
  goToProfile: () => {
    if (!navigate) throw new Error('Navigation not initialized');
    navigate("/profile");
  },

  // Auth
  goToLogin: () => {
    if (!navigate) throw new Error('Navigation not initialized');
    navigate("/login");
  },
  goToSignUp: () => {
    if (!navigate) throw new Error('Navigation not initialized');
    navigate("/signup");
  },
  goToVerify: () => {
    if (!navigate) throw new Error('Navigation not initialized');
    navigate("/verify");
  },

  // Navigation
  goBack: (defaultPath: string = "/home") => {
    if (!navigate) throw new Error('Navigation not initialized');
    const urlParams = new URLSearchParams(window.location.search);
    const source = urlParams.get("source");
    
    if (source) {
      navigate(`/${source}`);
    } else {
      navigate(defaultPath);
    }
  },
};
